import {FC} from "react";
import {ReportPage, ReportSalesInGraphSearchPanel} from "../../../components";
import {getPageNameByPageId, getSystemLanguageId, getUserId} from "../../../utils";
import {SearchReportEmployeeEsthkakSubtracts} from "../../../serviceBroker/employeeReportApiServiceBroker";
import {PageEnum, SalesInGraphReportSearchParamsModel} from "../../../models";

export const ReportEmployeeEsthkakSubtractsPage: FC = () => {
    const initialState: SalesInGraphReportSearchParamsModel = {
        Lang: getSystemLanguageId(),
        userId: getUserId(),
    };
    return (
        <ReportPage
            InitialState={initialState}
            SearchApi={SearchReportEmployeeEsthkakSubtracts}
            searchHeader={getPageNameByPageId(PageEnum.ReportAdditionAndSubtractsOfEmp)}
            SearchPanel={ReportSalesInGraphSearchPanel}
            formId={PageEnum.ReportAdditionAndSubtractsOfEmp}
        />
    );
};
